import {
    CmsEditableFields,
    CmsFlexibleBackgroundFields,
    CmsHeadingFields,
    CmsTextOverlayFields,
} from '@activebrands/core-web/libs/storyblok/content/cms-module-content';
import { RawNewsletter, RawSplitData } from '@activebrands/core-web/libs/storyblok/storyblok';
import extractBackgroundOverlays from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import { RawBackgroundData } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformLayout from '@activebrands/core-web/libs/storyblok/utils/transform-layout';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformTag from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import Newsletter from 'components/content-components/Newsletter';

export interface NewsletterContent
    extends CmsEditableFields, CmsFlexibleBackgroundFields, CmsHeadingFields, CmsTextOverlayFields {
    newsletter?: RawNewsletter[];
}

export interface NewsletterDataTransformerBlockProps {
    content?: NewsletterContent;
    isFourColumns?: boolean;
    isPopup?: boolean;
    isThreeColumns?: boolean;
    isTwoColumns?: boolean;
}

const NewsletterDataTransformerBlock = ({
    content = {},
    isFourColumns = false,
    isPopup = false,
    isThreeColumns = false,
    isTwoColumns = false,
}: NewsletterDataTransformerBlockProps) => {
    const {
        _editable,
        _uid,
        anchorTag = [],
        backgroundDesktop = [],
        backgroundMobile = [],
        newsletter = [],
        heading = [],
        paragraph = [],
        tag = [],
        textColor = '',
    } = content;

    const backgrounds = [backgroundMobile[0], null, null, null, backgroundDesktop[0]] as (
        | RawBackgroundData
        | RawSplitData
    )[];

    const backgroundOverlays = extractBackgroundOverlays(backgrounds);
    const transformedBackgrounds = transformFlexibleBackgrounds(backgrounds, 1);

    const transformedHeading = transformHeading({
        heading,
        defaultType: isFourColumns || isPopup || isThreeColumns || isTwoColumns ? 'h3' : 'h2',
    });

    const layout = transformLayout({ isTwoColumns, isThreeColumns, isFourColumns });

    return (
        <Newsletter
            background={transformedBackgrounds}
            backgroundLoading="eager"
            backgroundOverlay={backgroundOverlays}
            contentLayout={layout === 'oneColumn' && !isPopup ? 'default' : 'vertical'}
            heading={transformedHeading}
            id={transformAnchorTag({ anchorTag })}
            isPopup={isPopup}
            newsletter={newsletter?.[0]}
            paragraph={transformParagraph({ paragraph })}
            optiId={_uid}
            sbEditable={transformPreviewEditable(_editable)}
            tag={transformTag({ tag })}
            textColor={textColor}
        />
    );
};

export default NewsletterDataTransformerBlock;
